module.exports = __webpack_public_path__ + "img/red_010.89cb9bcc.png";